import React, { useEffect, useState } from 'react';

import { sendGTMEvent } from '../../utils/analytics';
import { DOC_TYPE, GA4_KEY } from '../../utils/constants';

import { useApp } from '../../context/AppContext';
import styles from './OffertPopUp.module.css';
import PDFViewer from '../PDFViewer/PDFViewer';

const OffertPopUp = ({
  isOpen,
  onClose,
  type = '',
  required = false,
  needConfirm = false,
  onConfirm,
}) => {
  const { appDescription } = useApp();
  const [acceptOffert, setAcceptOffert] = useState(false);
  const [acceptPolicy, setAcceptPolicy] = useState(false);
  const [showContent, setShowContent] = useState(DOC_TYPE.offert);

  useEffect(() => {
    if (isOpen) {
      setAcceptOffert(false);
      setAcceptPolicy(false);
      sendGTMEvent(GA4_KEY.open_offert_popup);
    }
  }, [isOpen, type]);

  const canClose =
    !required ||
    (acceptOffert && acceptPolicy) ||
    showContent !== DOC_TYPE.offert;

  const handleClose = () => {
    if (canClose) {
      window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
      if (showContent !== DOC_TYPE.offert) {
        setShowContent(DOC_TYPE.offert);
      } else {
        onClose();
      }
    }
  };

  const handleDocumentChange = (docType) => {
    setShowContent(docType);
  };

  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
        <div
          className={`${styles.popupBody} ${
            type === DOC_TYPE.offert && required
              ? styles.bigPadding
              : styles.smallPadding
          }`}
        >
          {!required ? (
            <>
              {type === DOC_TYPE.offert && (
                <PDFViewer pdfUrl={appDescription?.agreements?.offer} />
              )}
              {type === DOC_TYPE.policy && (
                <PDFViewer pdfUrl={appDescription?.agreements?.privacy} />
              )}
              {type === DOC_TYPE.extra_func && (
                <PDFViewer pdfUrl={appDescription?.agreements?.terms} />
              )}
            </>
          ) : (
            <>
              {showContent === DOC_TYPE.offert && (
                <PDFViewer pdfUrl={appDescription?.agreements?.offer} />
              )}
              {showContent === DOC_TYPE.policy && (
                <PDFViewer pdfUrl={appDescription?.agreements?.privacy} />
              )}
              {showContent === DOC_TYPE.extra_func && (
                <PDFViewer pdfUrl={appDescription?.agreements?.terms} />
              )}
            </>
          )}
        </div>

        <div className={styles.popupFooter}>
          {required && showContent === DOC_TYPE.offert && (
            <div className={styles.checkboxContainer}>
              <button
                className={styles.linkButton}
                onClick={() => handleDocumentChange(DOC_TYPE.extra_func)}
              >
                Открыть Пользовательское соглашение
              </button>

              <button
                className={styles.linkButton}
                onClick={() => handleDocumentChange(DOC_TYPE.policy)}
              >
                Открыть политику конфиденциальности
              </button>

              <label className={styles.checkboxLabel}>
                <input
                  type='checkbox'
                  checked={acceptOffert}
                  onChange={() => setAcceptOffert(!acceptOffert)}
                  className={styles.checkbox}
                />
                <span className={styles.checkboxText}>
                  Я принимаю условия пользовательского соглашения
                </span>
              </label>

              <label className={styles.checkboxLabel}>
                <input
                  type='checkbox'
                  checked={acceptPolicy}
                  onChange={() => setAcceptPolicy(!acceptPolicy)}
                  className={styles.checkbox}
                />
                <span className={styles.checkboxText}>
                  Я согласен с политикой конфиденциальности
                </span>
              </label>
            </div>
          )}
          {needConfirm ? (
            <div className={styles.popupButtons}>
              <button className={styles.popupButton} onClick={onConfirm}>
                Подтвердить оферту
              </button>
              <button
                className={`${styles.popupButton} ${styles.cancelButton}`}
                onClick={handleClose}
              >
                Отмена
              </button>
            </div>
          ) : (
            <button
              className={`${styles.popupButton} ${
                !canClose ? styles.popupButtonDisabled : ''
              }`}
              onClick={handleClose}
              disabled={!canClose}
            >
              {!required
                ? 'Закрыть'
                : showContent === DOC_TYPE.offert
                ? 'Подтвердить оферту'
                : 'Назад'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OffertPopUp;
